var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.loading)?_c(_setup.SmeCard,[_c(_setup.AppLoading,{attrs:{"loading":""}})],1):(!_setup.hidden)?_c('div',{ref:"$map",staticClass:"flexible-work-map"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }